import React, { useState } from 'react'
import Field from '../../../controls/Field/Field'
import styles from './DateInput.module.sass'
import { toDateString } from '../../../../utils/date-utils'
import DatePicker from '../DatePicker/DatePicker'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import { Intent } from '../../../controls/Intent'
import clsx from 'clsx'
import { Modifier } from 'react-day-picker'
import CalendarIcon from '../../../../../files/calendar.svg'
import Popover from '../../../etc/Popover'

interface Props {
    className?: string,
    value?: Date,
    onChange?: (date: Date) => void,
    placeholder?: string,
    intent?: Intent,
    disabledDays?: Modifier,
}

const DateInput: React.FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)

    return <Popover
        padding={2}
        align={'center'}
        isOpen={open}
        onClickOutside={() => setOpen(false)}
        content={state => <ShadowContainer state={state}>
            <DatePicker
                value={props.value}
                disabledDays={props.disabledDays}
                onChange={date => {
                    props.onChange?.(date)
                    setOpen(false)
                }}
            />
        </ShadowContainer>}
    >
        <Field
            block
            className={clsx(props.className, styles.field)}
            value={props.value ? toDateString(props.value) : props.placeholder}
            readonly
            onFocus={() => setOpen(true)}
            rightItem={<CalendarIcon/>}
            placeholder={props.placeholder}
            intent={props.intent}
        />
    </Popover>
}

export default DateInput
